module.exports = __webpack_public_path__ + "static/media/coins.9fdeb140.svg";